import { NavLink } from "react-router-dom";

function Navbar() {
  return (
    <nav className="Navbar">
      <ul>
        <li>
          <NavLink to="/" end>
            <img src="/segv.jpeg" alt="segv" className="Navbar-avatar" />
            segv
          </NavLink>
        </li>
        <li>
          <NavLink to="/blog">blog</NavLink>
        </li>
        <li>
          <NavLink to="/about">about</NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
